import { createApp } from 'vue';
import VStripePayment from './components/VStripePayment.vue';
import VRecoverPassword from './components/VRecoverPassword.vue';
import VSubscriptionPage from './components/VSubscriptionPage.vue';
import VStripeLoginModal from './components/VStripeLoginModal.vue';
import VLoginButton from './components/VLoginButton.vue';

createApp({})
  .component('VStripePayment', VStripePayment).mount('#stripe-checkout');

createApp({})
  .component('VSubscriptionPage', VSubscriptionPage).mount('#v-subscription-page');

createApp({})
  .component('VRecoverPassword', VRecoverPassword).mount('#v-recover-password-page');

createApp({})
  .component('VLoginButton', VLoginButton).mount('#v-login-button');

createApp({})
  .component('VStripeLoginModal', VStripeLoginModal).mount('#stripeLogin');
